export enum IncomePeriod {
  Annually = 'ANNUALLY',
  BiWeekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
}

export interface GrossIncomeFormFieldValue {
  income: number;
  incomePeriod: IncomePeriod;
}
